<template>
    <div id="services" class="overflow-hidden">
        <div class="position-relative container-wrapper overflow-hidden">
            <div class="col-md-4 col-display left" v-scrollanimation>
                <div class="column-inner">
                    <div class="wrapper">
                        <div class="position-relative bg-img-atr s-main-bg01"></div>
                        <div class="position-absolute overlay overlay-bg-lightdark">
                            <div class="service-item-wrapper d-flex flex-column justify-content-end">
                                <h4 class="white-color">{{dataText.marketingAndWeb.title}}</h4>
                                <router-link to="marketing" href="#marketing"><i>{{dataText.more}}</i> &rarr;</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-display left" v-scrollanimation>
                <div class="column-inner">
                    <div class="wrapper">
                        <div class="position-relative bg-img-atr s-main-bg02"></div>
                        <div class="position-absolute overlay overlay-bg-lightdark">
                            <div class="service-item-wrapper d-flex flex-column justify-content-end">
                                <h4 class="white-color">{{dataText.visual.title}}</h4>
                                <router-link to="visuals"><i>{{dataText.more}}</i> &rarr;</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-display left" v-scrollanimation>
                <div class="column-inner">
                    <div class="wrapper">
                        <div class="position-relative bg-img-atr s-main-bg03"></div>
                        <div class="position-absolute overlay overlay-bg-lightdark">
                            <div class="service-item-wrapper d-flex flex-column justify-content-end">
                                <h4 class="white-color">{{dataText.consulting.title}}</h4>
                                <router-link to="consulting"><i>{{dataText.more}}</i> &rarr;</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Services",
        props: {
            webData: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                dataText: this.webData.services
            }
        }
    }
</script>

<style>
    .service-item-wrapper {
        height: inherit;
        padding: 0 50px 25px;
    }
    .service-item-wrapper h4 {
        line-height: 10px;
    }
    .service-item-wrapper a {
        color: #fff;
    }
    .service-item-wrapper a:hover {
        color: #fff;
    }
    .container-wrapper {
        width: 100%;
        height: 100vh;
    }
    #services .container-wrapper div.col-md-4 {
        height: 100%;
        padding: 0;
    }
    .s-main-bg01 {
        background-image: url("../assets/photos/h3_marketing_main.jpg");
        height: 100vh;
    }
    .s-main-bg02 {
        background-image: url("../assets/photos/h3_savjetovanje_main.jpg");
        height: 100vh;
    }
    .s-main-bg03 {
        background-image: url("../assets/photos/h3_vizuali_main.jpg");
        height: 100vh;
    }

</style>